import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';
import { replaceToUpperCase } from 'shared/modules';
import JsonLdApplication from 'shared/components/JsonLdApplication/JsonLdApplication';

import s from './BreadcrumbsLinks.css';

const AB_PATH = 'https://avtobazar.ua';

const SpanLink = ({ text, index, intl }) => (
  <span>
    {index === 0
      ? replaceToUpperCase(intl.formatMessage({ id: text }))
      : intl.formatMessage({ id: text })}
  </span>
);

SpanLink.propTypes = {
  text: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
};

class BreadcrumbsLinks extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    history: PropTypes.shape({
      currentPath: PropTypes.string,
    }),
    links: PropTypes.arrayOf(PropTypes.array).isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    title: '',
    history: {
      currentPath: '',
    },
  };

  render() {
    const {
      links,
      history: { currentPath },
      intl,
    } = this.props;
    const hasQuery = !!currentPath.split('').find(item => item === '?');

    const breadcrumbItemListEl = links.map((a, b) => ({
      '@type': 'ListItem',
      position: b + 1,
      item: {
        '@id': `${AB_PATH}${a[0]}/`,
        name:
          b === 0
            ? replaceToUpperCase(intl.formatMessage({ id: a[1] }))
            : intl.formatMessage({ id: a[1] }),
      },
    }));

    const breadcrumbListLd = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItemListEl,
    };

    return (
      <div>
        <div className={cx(s.olNavigationLink)}>
          {links.map((a, b) => (
            <span className={s.itemListElement} key={`${b}${a[2]}`}>
              {b + 1 === links.length && !hasQuery ? (
                <span className={'meta-title-link-next'}>
                  <SpanLink text={a[1]} index={b} intl={intl} />
                </span>
              ) : (
                <li>
                  <Link
                    itemProp="url"
                    to={`${a[0]}/`}
                    className={cx({
                      'meta-title-link': b === 0,
                      'meta-title-link-next': b !== 0,
                    })}
                  >
                    <SpanLink text={a[1]} index={b} intl={intl} />
                  </Link>
                </li>
              )}
            </span>
          ))}
        </div>
        <JsonLdApplication {...breadcrumbListLd} />
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(BreadcrumbsLinks));



// WEBPACK FOOTER //
// ./src/shared/components/BreadcrumbsLinks/BreadcrumbsLinks.js